import { faBell } from '@fortawesome/pro-regular-svg-icons/faBell'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { t } from '@lingui/macro'
import { useTheme } from 'styled-components'

import { FlexColumn, Margin } from '@/@bothrs-ui/web/components/layout'
import { Modal } from '@/@bothrs-ui/web/components/modal/Modal'
import { Button } from '@/@bothrs-ui/web/components/primitives/button/Button'
import { P } from '@/@bothrs-ui/web/components/typography/Body'
import { H3 } from '@/@bothrs-ui/web/components/typography/Heading'

import type { InheritableModalProps } from '@/@bothrs-ui/web/components/modal/Modal.props'

type NotificationSettingsModalProps = InheritableModalProps & {
  onAction: () => void
}

const NotificationSettingsModal = ({ onAction, ...props }: NotificationSettingsModalProps) => {
  const theme = useTheme()

  return (
    <Modal {...props}>
      <FlexColumn alignContent='center'>
        <FontAwesomeIcon icon={faBell} fontSize={24} />

        <Margin mt={theme.UI.Spacing.Space5} />

        <H3 textAlign='center' color={theme.Colors.Neutrals.Darkest}>
          {t({
            id: 'notification.Setting-modal.title',
            comment: 'title for followup modal for permissions',
            message: 'Meldingen toch activeren',
          })}
        </H3>

        <P type='BodyLargeRegular' textAlign='center' color={theme.Colors.Neutrals.Darker}>
          {t({
            id: 'notification.Setting-modal.body',
            comment: 'body for followup modal for permissions',
            message:
              'Je kan je meldingen steeds activeren en deactiveren via je profiel onder ‘privacy & toestemming’.',
          })}
        </P>

        <Button variant='Primary' onClick={onAction}>
          {t({
            id: 'notification.Setting-modal.action.button',
            comment: 'action button for followup modal noti permissions',
            message: 'Ga naar profiel',
          })}
        </Button>
        <Margin mt={theme.UI.Spacing.Space2} />
        <Button variant='Tertiary' onClick={props.onClose}>
          {t({
            id: 'notification.Setting-modal.cancel.button',
            comment: 'cancel button for followup modal asking noti permissions',
            message: 'Sluiten',
          })}
        </Button>
      </FlexColumn>
    </Modal>
  )
}

export { NotificationSettingsModal }
